import { DollarsOnlyFormatter } from "@upserve/financials";
import { pathOr } from "ramda";
import { Maybe } from "true-myth";

import { getLastYear } from "helpers/dates";
import { percentage } from "helpers/math";
import { ISalesForecast } from "types/account";

export const EMPTY_VAL = "n/a";
export const NO_DATA = `No data available or ${getLastYear()} Gross Sales = $0`;

export function getSalesForecastValuesForDay(
  salesForecast: Maybe<ISalesForecast>,
  costThisDay: number,
  dayIndex: number
): string[] {
  const forecastThisDay = getSalesForecastForDay(salesForecast, dayIndex);
  return getValuesOrEmpty(costThisDay, forecastThisDay);
}

export function getSalesForecastForDay(
  salesForecast: Maybe<ISalesForecast>,
  dayIndex: number
): number {
  return salesForecast.match({
    Just: pathOr(0, ["daily", dayIndex, "grossSalesAmount"]),
    Nothing: () => 0,
  });
}

export function getDollarsOrEmpty(dollars: number): string {
  return dollars ? DollarsOnlyFormatter.format(dollars) : EMPTY_VAL;
}

export function getPercentOrEmpty(
  numerator: number,
  denominator: number
): string {
  return denominator ? percentage(numerator, denominator) : EMPTY_VAL;
}

export function getValuesOrEmpty(cost: number, forecast: number): string[] {
  return [getDollarsOrEmpty(forecast), getPercentOrEmpty(cost, forecast)];
}
